<template>
  <div class="property-block" :class="{ 'breakpoint-md': breakpoint === 'md' }">
    <div class="property-block__text">
      <slot name="text" />
    </div>

    <div v-if="slots.content" class="property-block__content" :style="{ maxWidth: contentMaxWidth }">
      <slot name="content" />
      <div v-if="slots.right && $vuetify.display.mdAndDown" class="property-block__right">
        <slot name="right" />
      </div>
    </div>
    <div v-if="slots.right && !$vuetify.display.mdAndDown" class="property-block__right">
      <slot name="right" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  contentMaxWidth?: string;
  breakpoint?: 'md';
}>();

const slots = defineSlots<{
  text: () => void;
  content?: () => void;
  right?: () => void;
}>();
</script>

<style scoped lang="scss">
.property-block {
  display: flex;

  &.breakpoint-md {
    @include md-and-down {
      flex-direction: column;

      .property-block__text {
        &:not(:empty) {
          margin-bottom: 24px;
        }
      }
    }
  }

  @include sm-and-down {
    flex-direction: column;
  }

  &__text {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 100%;

    max-width: 354px;
    margin-right: 24px;

    @include rwd(1640px) {
      max-width: 282px;
    }

    @include lg-and-down {
      max-width: 250px;
    }
    @include md-and-down {
      max-width: 274px;
    }

    @include sm-and-down {
      flex-basis: initial;

      max-width: 100%;
      margin-right: 0;

      &:not(:empty) {
        margin-bottom: 16px;
      }
    }
  }

  &__content {
    flex-grow: 1;

    max-width: 640px;

    @include md-and-down {
      max-width: 100%;
    }
  }

  &__right {
    display: flex;

    margin-left: auto;
    padding-left: 24px;

    @include md-and-down {
      margin-top: 24px;
      padding-left: 0;
    }
  }
}
</style>
